import Printables from './Printables';

export default Printables;
